.iconBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: var(--radius-sm);
  color: var(--text-secondary);
  transition: background-color var(--dur-fast) var(--ease), color var(--dur-fast) var(--ease);
  flex-shrink: 0;
}

.iconBtn:hover:not(:disabled) {
  background: var(--surface-hover);
  color: var(--text-primary);
}

.iconBtn:active:not(:disabled) {
  background: var(--surface-active);
}

.iconBtn:disabled {
  opacity: 0.4;
  cursor: default;
}

.active {
  color: var(--accent-text);
  background: var(--accent-subtle);
}
.active:hover:not(:disabled) {
  background: var(--accent-subtle);
  color: var(--accent-text);
}

.rail {
  width: 32px;
  height: 32px;
}
